var _defs, _rect, _rect2, _rect3, _path, _line, _line2, _rect4, _path2, _line3, _line4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgInfo = function SvgInfo(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "info",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 91.46 91.46",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{stroke:#7b8fb5;stroke-width:4px;}.cls-1,.cls-2,.cls-3{fill:none;stroke-miterlimit:10;}.cls-1,.cls-3{stroke-linecap:round;}.cls-3{stroke:#fff;stroke-width:2px;}.cls-4{fill:#7b8fb5;stroke-width:0px;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 3.75,
    y: 3.2,
    width: 83.95,
    height: 85.07,
    rx: 1.48,
    ry: 1.48
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 11.6,
    y: 14.19,
    width: 68.27,
    height: 24.83,
    rx: 1.48,
    ry: 1.48
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 62.04,
    y: 19.8,
    width: 13.19,
    height: 13.61,
    rx: 0.92,
    ry: 0.92
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m64.47,26.68l2.63,2.63c.07.07.18.07.24,0l5.46-5.46"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 20.55,
    y1: 26.17,
    x2: 29.38,
    y2: 26.17
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 36.9,
    y1: 26.17,
    x2: 54.58,
    y2: 26.17
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 11.6,
    y: 52.44,
    width: 68.27,
    height: 24.83,
    rx: 1.48,
    ry: 1.48
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m71.24,62.05v5.61h-5.19v-5.61h5.19m3.08-4h-11.35c-.51,0-.92.41-.92.92v11.77c0,.51.41.92.92.92h11.35c.51,0,.92-.41.92-.92v-11.77c0-.51-.41-.92-.92-.92h0Z"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 20.55,
    y1: 64.41,
    x2: 39.8,
    y2: 64.41
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 47.58,
    y1: 64.41,
    x2: 54.58,
    y2: 64.41
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgInfo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "info.623962c8a45b9dbc56a89504314990a1.svg";